import { useState } from "react";

export type ProductInfo = {
  title: string;
  content: string;
};

export const useProductInfoDrawer = () => {
  const [activeProduct, setActiveProduct] = useState<ProductInfo | null>(null);

  return {
    isOpen: !!activeProduct,
    activeProduct,
    openDrawer: (product: ProductInfo) => setActiveProduct(product),
    closeDrawer: () => setActiveProduct(null),
  };
};
